import EmptyState from "./EmptyState";

export default function DataTable({ columns, data, getRowKey, rowClassName }) {
  if (!data?.length) {
    return <EmptyState text="No records found." />;
  }

  return (
    <div className="table-wrap">
      <table className="admin-table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key}>{column.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row) => {
            const className = rowClassName ? rowClassName(row) : "";

            return (
              <tr key={getRowKey(row)} className={className}>
                {columns.map((column) => (
                  <td key={column.key}>{column.render(row)}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}